// IMPORT PROJECT REFERENCES
import { AnalysesBrowser } from '../Analysis/AnalysesBrowser';
import Can from '../Can';
// IMPORT PACKAGE REFERENCES
import React from 'react';

// COMPONENT
export const AnalysesPage = () => (
    <div className="p-3">
        <Can I="read" a="Analysis">
            <AnalysesBrowser />
        </Can>
    </div>
);
